import { render, staticRenderFns } from "./RadarTrendList.vue?vue&type=template&id=a88285ec&scoped=true"
import script from "./RadarTrendList.vue?vue&type=script&lang=js"
export * from "./RadarTrendList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a88285ec",
  null
  
)

export default component.exports